export default __webpack_public_path__ + "static/media/dismiss-keyboard-error-autoscroll.469ea90b.gif";